import React, { FunctionComponent } from 'react';

import { useHistory } from 'react-router-dom';

import Button from '@material-ui/core/Button';

type SecondaryButtonWithRoute = {
  onClick?: never;
  route: '/' | 'story' | 'data' | 'imprint';
};

type SecondaryButtonWithOnClick = {
  onClick: () => void;
  route?: never;
};

type SecondaryButton = (
  | SecondaryButtonWithRoute
  | SecondaryButtonWithOnClick
) & { disabled?: boolean; tabIndex: number };

const SecondaryButton: FunctionComponent<SecondaryButton> = ({
  children,
  disabled,
  onClick,
  route,
  tabIndex,
}) => {
  const { push } = useHistory();

  if (!onClick && route) {
    onClick = () => push(route);
  }

  return (
    <Button
      disabled={disabled}
      variant="contained"
      color="secondary"
      onClick={onClick}
      tabIndex={tabIndex}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;
